/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { makeT9nController as o } from "@arcgis/lumina/controllers";
import { g as t } from "./runtime.js";
const s = o(t);
export {
  s as u
};
